const metaSourceCity =
  [
    {
      "sourceId": "a01",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>人口等基本集計"
    },
    {
      "sourceId": "a02",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>人口等基本集計"
    },
    {
      "sourceId": "a03",
      "source": "総務省自治行政局住民制度課<br>「住民基本台帳に基づく人口，人口動態及び世帯数調査（住民基本台帳人口要覧）」<br>＜毎年＞"
    },
    {
      "sourceId": "a04",
      "source": "厚生労働省政策統括官付参事官付<br>「人口動態統計」<br>＜毎年＞"
    },
    {
      "sourceId": "a05",
      "source": "総務省統計局<br>「住民基本台帳人口移動報告年報」<br>A5102～A510202は2009年までは<br>都道府県担当課<br>「都道府県資料」"
    },
    {
      "sourceId": "a06",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>従業地・通学地集計"
    },
    {
      "sourceId": "a07",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>人口等基本集計"
    },
    {
      "sourceId": "a08",
      "source": "総務省自治行政局住民制度課<br>「住民基本台帳に基づく人口，人口動態及び世帯数調査（住民基本台帳人口要覧）」<br>＜毎年＞"
    },
    {
      "sourceId": "a09",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>人口等基本集計"
    },
    {
      "sourceId": "a10",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>産業等基本集計<br>世帯構造等基本集計"
    },
    {
      "sourceId": "a11",
      "source": "厚生労働省政策統括官付参事官付<br>「人口動態統計」<br>＜毎年＞"
    },
    {
      "sourceId": "b01",
      "source": "・国勢調査実施年<br>総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>人口等基本集計<br>・国勢調査実施年以外<br>国土交通省国土地理院<br>「全国都道府県市区町村別面積調」<br>＜毎年＞"
    },
    {
      "sourceId": "b02",
      "source": "農林水産省大臣官房統計情報部<br>「世界農林業センサス・林業地域調査報告書」<br>＜10年毎＞<br>「農林業センサス」<br>＜10年毎＞"
    },
    {
      "sourceId": "b03",
      "source": "総務省自治税務局<br>「固定資産の価格等の概要調書（土地）」<br>2008年までは都道府県担当課<br>「都道府県資料」<br>＜毎年＞"
    },
    {
      "sourceId": "c01",
      "source": "総務省自治税務局<br>「市町村税課税状況等の調」<br>＜毎年＞"
    },
    {
      "sourceId": "c02",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "c03",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c04",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜5年毎＞<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "c05",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜5年毎＞<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "c06",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜5年毎＞<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "c07",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c08",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」"
    },
    {
      "sourceId": "c09",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c10",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」"
    },
    {
      "sourceId": "c11",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c12",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c13",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜5年毎＞<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "c14",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜5年毎＞<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "c15",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜5年毎＞<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。<br>総務省統計局<br>「経済センサス-基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c16",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」"
    },
    {
      "sourceId": "c17",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c18",
      "source": "農林水産省大臣官房統計情報部<br>「生産農業所得統計」<br>＜毎年＞"
    },
    {
      "sourceId": "c19",
      "source": "農林水産省大臣官房統計情報部<br>「農林業センサス」，「農業センサス」<br>＜５年毎＞"
    },
    {
      "sourceId": "c20",
      "source": "農林水産省大臣官房統計部<br>｢耕地及び作付面積統計」<br>＜毎年＞"
    },
    {
      "sourceId": "c21",
      "source": "農林水産省大臣官房統計情報部<br>「世界農林業センサス」「農林業センサス」<br>＜５年毎＞"
    },
    {
      "sourceId": "c22",
      "source": "・経済センサス－活動調査実施年<br>総務省統計局及び経済産業省大臣官房調査統計グループ<br>「経済センサス－活動調査」<br>・経済センサス－活動調査実施年以外<br>経済産業省大臣官房調査統計グループ<br>「工業統計調査」<br>＜毎年＞"
    },
    {
      "sourceId": "c23",
      "source": "・経済センサス－活動調査実施年<br>総務省統計局及び経済産業省大臣官房調査統計グループ<br>「経済センサス－活動調査」<br>・経済センサス－活動調査実施年以外<br>経済産業省大臣官房調査統計グループ<br>「商業統計調査」<br>＜毎年＞<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "c24",
      "source": "都道府県担当課<br>「都道府県資料」"
    },
    {
      "sourceId": "c25",
      "source": "総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜５年毎＞<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "c26",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜5年毎＞<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "c27",
      "source": "総務省統計局<br>「経済センサス-基礎調査」<br>総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜5年毎＞<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "d01",
      "source": "総務省自治行政局<br>「地方公共団体定員管理調査」<br>＜毎年＞"
    },
    {
      "sourceId": "d02",
      "source": "総務省自治財政局<br>「地方財政統計年報」<br>「市町村別決算状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "d03",
      "source": "総務省自治財政局<br>「地方財政統計年報」<br>「市町村別決算状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "d04",
      "source": "総務省自治財政局<br>「地方財政統計年報」<br>「市町村別決算状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "e01",
      "source": "文部科学省生涯学習政策局<br>「学校基本調査」<br>2009年までは都道府県担当課「都道府県資料」<br>2013年度までは「学校基本調査」結果を総務省統計局が集計"
    },
    {
      "sourceId": "e02",
      "source": "総務省統計局<br>「国勢調査報告」<br>産業等基本集計・大規模調査のみ"
    },
    {
      "sourceId": "f01",
      "source": "総務省統計局<br>「国勢調査報告」<br>産業等基本集計<br>就業状態等基本集計<br>＜５年毎＞"
    },
    {
      "sourceId": "f02",
      "source": "総務省統計局<br>「国勢調査報告」<br>抽出詳細集計<br>＜５年毎＞"
    },
    {
      "sourceId": "f03",
      "source": "総務省統計局<br>「国勢調査報告」<br>産業等基本集計<br>就業状態等基本集計<br>＜５年毎＞"
    },
    {
      "sourceId": "f04",
      "source": "総務省統計局<br>「国勢調査報告」<br>産業等基本集計<br>就業状態等基本集計<br>＜５年毎＞"
    },
    {
      "sourceId": "f05",
      "source": "総務省統計局<br>「国勢調査報告」<br>従業地・通学地集計<br>従業地・通学地による人口・就業状態等集計<br>＜５年毎＞"
    },
    {
      "sourceId": "g01",
      "source": "文部科学省生涯学習政策局<br>「社会教育調査報告」<br>＜３年毎＞"
    },
    {
      "sourceId": "h01",
      "source": "総務省統計局 <br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h02",
      "source": "国土交通省総合政策局<br>「建築統計年報」（住宅着工統計調査）<br>＜毎年＞"
    },
    {
      "sourceId": "h03",
      "source": "国土交通省総合政策局<br>「建築統計年報」（住宅着工統計調査）<br>＜毎年＞"
    },
    {
      "sourceId": "h04",
      "source": "総務省統計局 <br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h05",
      "source": "総務省統計局 <br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h06",
      "source": "国土交通省総合政策局<br>「建築統計年報」（建築着工統計調査）<br>＜毎年＞<br>（住宅着工統計調査）<br>＜毎年＞"
    },
    {
      "sourceId": "h07",
      "source": "総務省統計局 <br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h08",
      "source": "総務省統計局 <br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h09",
      "source": "総務省統計局<br>「国勢調査報告」人口等基本集計<br>＜５年毎＞"
    },
    {
      "sourceId": "h10",
      "source": "総務省統計局 <br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h11",
      "source": "総務省統計局<br>「国勢調査報告」人口等基本集計<br>＜５年毎＞"
    },
    {
      "sourceId": "h12",
      "source": "総務省統計局 <br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h13",
      "source": "総務省統計局 <br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h14",
      "source": "総務省自治財政局<br>「公共施設状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "h15",
      "source": "環境省大臣官房<br>廃棄物・リサイクル対策部<br>「一般廃棄物処理事業実態調査」<br>＜毎年＞"
    },
    {
      "sourceId": "h16",
      "source": "総務省自治財政局<br>「公共施設状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "h17",
      "source": "環境省大臣官房<br>廃棄物・リサイクル対策部<br>「一般廃棄物処理事業実態調査」<br>＜毎年＞"
    },
    {
      "sourceId": "h18",
      "source": "総務省統計局<br>「事業所・企業統計調査報告"
    },
    {
      "sourceId": "h19",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>総務省統計局及び経済産業省大臣官房調査統計グループ<br>「経済センサス－活動調査」<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "h20",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "h21",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>総務省統計局及び経済産業省大臣官房調査統計グループ<br>「経済センサス－活動調査」<br>※経済センサスについては,５年周期であるが，活動調査の時期は，基礎調査の実施から約２～３年である。"
    },
    {
      "sourceId": "h22",
      "source": "・経済センサス－活動調査実施年<br>総務省統計局及び経済産業省大臣官房調査統計グループ<br>「経済センサス－活動調査」<br>・経済センサス－活動調査実施年以外<br>経済産業省大臣官房調査統計グループ<br>「商業統計調査」"
    },
    {
      "sourceId": "h23",
      "source": "総務省自治税務局<br>「軽自動車税に関する調」"
    },
    {
      "sourceId": "h24",
      "source": "総務省統計局<br>「国勢調査報告」<br>従業地・通学地集計<br>大規模調査のみ＜１０年毎＞"
    },
    {
      "sourceId": "h25",
      "source": "総務省統計局<br>「住宅・土地統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "h26",
      "source": "日本放送協会<br>「放送受信契約数統計要覧」<br>＜毎年＞"
    },
    {
      "sourceId": "h27",
      "source": "国土交通省都市局<br>「都市計画年報」<br>＜毎年＞"
    },
    {
      "sourceId": "i01",
      "source": "厚生労働省大臣官房統計情報部<br>「市区町村別生命表」「完全生命表」<br>＜５年＞"
    },
    {
      "sourceId": "i02",
      "source": "厚生労働省大臣官房統計情報部<br>「医療施設調査・病院報告｣<br>＜毎年＞"
    },
    {
      "sourceId": "i03",
      "source": "厚生労働省大臣官房統計情報部<br>「医療施設調査・病院報告｣<br>＜毎年＞"
    },
    {
      "sourceId": "i04",
      "source": "厚生労働省大臣官房統計情報部<br>「介護サービス施設・事業所調査」"
    },
    {
      "sourceId": "i05",
      "source": "厚生労働省大臣官房統計情報部<br>「医師・歯科医師・薬剤師調査」<br>＜隔年＞"
    },
    {
      "sourceId": "j01",
      "source": "厚生労働省大臣官房統計情報部<br>「社会福祉施設等調査」"
    },
    {
      "sourceId": "j02",
      "source": "厚生労働省大臣官房統計情報部<br>「介護サービス施設・事業所調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j03",
      "source": "厚生労働省大臣官房統計情報部<br>「社会福祉施設等調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j04",
      "source": "厚生労働省大臣官房統計情報部<br>「社会福祉施設等調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j05",
      "source": "厚生労働省大臣官房統計情報部<br>「社会福祉施設等調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j06",
      "source": "厚生労働省大臣官房統計情報部<br>「社会福祉施設等調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j07",
      "source": "厚生労働省保険局調査課<br>「国民健康保険事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "k01",
      "source": "都道府県担当課<br>「都道府県資料」<br>＜毎年＞"
    }
  ];

export default metaSourceCity



